import { SITE, KEYWORDS_DEFAULT } from './site';

const K = KEYWORDS_DEFAULT;

/** @typedef {{ title: string, description: string, keywords?: string, robots?: string, breadcrumb?: { name: string, path: string }[], noindex?: boolean }} SeoRoute */

/** @type {Record<string, SeoRoute>} */
export const SEO_ROUTES = {
  '/': {
    title: 'Richard SAAD - Consultant Informatique à Lyon | SAAD Informatique',
    description:
      'Richard SAAD, consultant informatique indépendant à Lyon et dans le Rhône (SAAD Informatique). Infogérance, dépannage, infrastructure, sécurité et Microsoft 365 pour TPE et PME.',
    keywords: `${K}, consultant it lyon, richard saad informatique`,
    breadcrumb: [{ name: 'Accueil', path: '/' }],
  },
  '/services': {
    title: 'Services informatiques Lyon & Rhône | SAAD Informatique',
    description:
      'Infogérance, dépannage, projets réseau, Microsoft 365, sécurité et conseil IT à Lyon et en Auvergne-Rhône-Alpes. Prestations sur mesure pour TPE et PME.',
    keywords: `services informatiques lyon, prestataire informatique rhone, ${K}`,
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Services', path: '/services' },
    ],
  },
  '/services/infogerance': {
    title: 'Infogérance Lyon | Maintenance informatique TPE/PME — SAAD Informatique',
    description:
      'Infogérance et maintenance informatique à Lyon : serveurs, postes, réseau, sauvegardes et mises à jour. Un interlocuteur unique pour stabiliser votre parc.',
    keywords: 'infogérance lyon, infogerance lyon, maintenance informatique lyon, gestion parc informatique rhone',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'Infogérance', path: '/services/infogerance' },
    ],
  },
  '/services/depannage': {
    title: 'Dépannage informatique Lyon | Support IT à distance — SAAD Informatique',
    description:
      'Dépannage informatique rapide à Lyon et région : connexion, lenteurs, messagerie, imprimantes, accès distant. Intervention ponctuelle ou régulière.',
    keywords: 'dépannage informatique lyon, support informatique lyon, assistance informatique rhone',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'Dépannage', path: '/services/depannage' },
    ],
  },
  '/services/infrastructure': {
    title: 'Infrastructure informatique Lyon | Réseau, serveurs, Wi-Fi — SAAD Informatique',
    description:
      'Projets d\'infrastructure informatique à Lyon : serveurs, réseau, Wi-Fi, segmentation et sécurisation des accès pour entreprises.',
    keywords: 'infrastructure informatique lyon, réseau entreprise lyon, serveur lyon, wifi entreprise rhone',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'Infrastructure', path: '/services/infrastructure' },
    ],
  },
  '/services/m365': {
    title: 'Microsoft 365 Lyon | Migration cloud & messagerie — SAAD Informatique',
    description:
      'Accompagnement Microsoft 365 à Lyon : migration, messagerie, Teams, SharePoint, télétravail et optimisation des licences pour TPE/PME.',
    keywords: 'microsoft 365 lyon, migration office 365 lyon, cloud entreprise lyon',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'Microsoft 365', path: '/services/m365' },
    ],
  },
  '/services/securite': {
    title: 'Sécurité informatique Lyon | Sauvegarde & cybersécurité — SAAD Informatique',
    description:
      'Sécurité informatique et sauvegardes à Lyon : pare-feu, antivirus, droits utilisateurs, sauvegardes locales et cloud pour protéger vos données.',
    keywords: 'sécurité informatique lyon, sauvegarde données lyon, cybersécurité pme rhone',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'Sécurité', path: '/services/securite' },
    ],
  },
  '/services/conseil-dsi': {
    title: 'Conseil informatique & DSI externalisée Lyon — SAAD Informatique',
    description:
      'Audit, conseil IT et DSI à temps partagé à Lyon. Priorisation des investissements, choix de solutions et accompagnement des dirigeants TPE/PME.',
    keywords: 'conseil informatique lyon, audit informatique lyon, dsi externalisée lyon',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'Conseil & DSI', path: '/services/conseil-dsi' },
    ],
  },
  '/methode': {
    title: 'Méthode d\'accompagnement IT | Consultant informatique Lyon',
    description:
      'Découvrez ma méthode : échange initial, audit, plan d\'action et suivi dans la durée. Une approche claire pour les entreprises de Lyon et du Rhône.',
    keywords: `méthode consultant informatique lyon, accompagnement it pme, ${K}`,
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Méthode', path: '/methode' },
    ],
  },
  '/realisations': {
    title: 'Réalisations informatiques Lyon | Cas clients TPE/PME — SAAD Informatique',
    description:
      'Exemples de projets IT réalisés : infrastructure, réseau, supervision, MCO et Microsoft 365 pour TPE, PME et collectivités en région lyonnaise.',
    keywords: 'réalisations informatique lyon, projets it rhone, consultant informatique références',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Réalisations', path: '/realisations' },
    ],
  },
  '/a-propos': {
    title: 'À propos | Richard SAAD — Consultant informatique Lyon',
    description:
      'Richard SAAD, consultant informatique indépendant basé à Lyon. Expertise systèmes, réseaux, sécurité et cloud au service des TPE et PME du Rhône.',
    keywords: 'richard saad informatique, consultant informatique indépendant lyon, saad informatique',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'À propos', path: '/a-propos' },
    ],
  },
  '/contact': {
    title: 'Contact | Consultant informatique Lyon — SAAD Informatique',
    description:
      'Contactez SAAD Informatique à Lyon : formulaire, email richard@saad-informatique.fr ou RDV visio 30 min gratuit. Réponse rapide pour TPE et PME.',
    keywords: 'contact informatique lyon, devis informatique lyon, saad informatique contact',
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Contact', path: '/contact' },
    ],
  },
  '/mentions-legales': {
    title: 'Mentions légales | SAAD Informatique',
    description: 'Mentions légales du site saad-informatique.fr — Richard SAAD, consultant informatique à Lyon.',
    robots: 'noindex, follow',
    noindex: true,
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Mentions légales', path: '/mentions-legales' },
    ],
  },
  '/confidentialite': {
    title: 'Politique de confidentialité | SAAD Informatique',
    description: 'Politique de confidentialité et protection des données personnelles — SAAD Informatique, Lyon.',
    robots: 'noindex, follow',
    noindex: true,
    breadcrumb: [
      { name: 'Accueil', path: '/' },
      { name: 'Confidentialité', path: '/confidentialite' },
    ],
  },
};

export const DEFAULT_SEO = SEO_ROUTES['/'];

/**
 * @param {string} pathname
 * @returns {SeoRoute}
 */
export function getSeoForPath(pathname) {
  const path = pathname.endsWith('/') && pathname.length > 1
    ? pathname.slice(0, -1)
    : pathname;
  return SEO_ROUTES[path] || DEFAULT_SEO;
}

export function absoluteUrl(path = '/') {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${SITE.url}${p}`;
}
